// extracted by mini-css-extract-plugin
export var growableInput = "_8a-0";
export var tagContainer = "_8a-2";
export var textInput = "_8a-1";